// Values of the marketing `check` constraints, in display order, with their
// i18n keys and colours.
import type {
  ChannelStatus,
  ContentFormat,
  ContentStatus,
  ContentVertical,
  MetricSource,
  PlanStatus,
} from "./types";

export const CONTENT_STATUSES: readonly ContentStatus[] = [
  "idea",
  "guion",
  "produccion",
  "programado",
  "publicado",
];

export const CONTENT_FORMATS: readonly ContentFormat[] = [
  "imagen",
  "carrusel",
  "reel",
  "short",
  "video_largo",
  "post",
  "story",
  "anuncio",
  "articulo",
  "otro",
];

export const CONTENT_VERTICALS: readonly ContentVertical[] = [
  "clinicas",
  "inmobiliarias",
  "pymes",
  "general",
  "otro",
];

export const CHANNEL_STATUSES: readonly ChannelStatus[] = ["activo", "pausado"];

export const PLAN_STATUSES: readonly PlanStatus[] = [
  "borrador",
  "activo",
  "finalizado",
];

export const METRIC_SOURCES: readonly MetricSource[] = [
  "manual",
  "agente",
  "api",
];

export const isContentStatus = (value: unknown): value is ContentStatus =>
  CONTENT_STATUSES.includes(value as ContentStatus);

export const isContentFormat = (value: unknown): value is ContentFormat =>
  CONTENT_FORMATS.includes(value as ContentFormat);

export const statusLabelKey = (status: ContentStatus): string =>
  `marketing.status.${isContentStatus(status) ? status : "idea"}`;
export const formatLabelKey = (format: ContentFormat): string =>
  `marketing.format.${isContentFormat(format) ? format : "otro"}`;
export const verticalLabelKey = (vertical: ContentVertical): string =>
  `marketing.vertical.${CONTENT_VERTICALS.includes(vertical) ? vertical : "general"}`;
export const planStatusLabelKey = (status: PlanStatus): string =>
  `marketing.plan_status.${PLAN_STATUSES.includes(status) ? status : "activo"}`;
export const channelStatusLabelKey = (status: ChannelStatus): string =>
  `marketing.channel_status.${status === "pausado" ? "pausado" : "activo"}`;

/** Kanban dot / calendar chip colour of each status. */
export const STATUS_COLOR: Record<ContentStatus, string> = {
  idea: "#94a3b8",
  guion: "#8b5cf6",
  produccion: "#f59e0b",
  programado: "#0ea5e9",
  publicado: "#10b981",
};

/** Pillars without a colour get one of these, by position. */
export const PILLAR_PALETTE: readonly string[] = [
  "#2563eb",
  "#dc2626",
  "#059669",
  "#d97706",
  "#7c3aed",
  "#db2777",
  "#0891b2",
];
